var showLink = document.querySelector('.showhide');
	showLink.addEventListener('click', function(e){
		e.preventDefault();
		toogleAdvantages();
	});

function toogleAdvantages () {
	var icon = showLink.querySelector('.fa');
	if (icon.matches('.fa-angle-down')) {
		icon.classList.remove('fa-angle-down');
		icon.classList.add('fa-angle-up');
	} else {
		icon.classList.add('fa-angle-down');
		icon.classList.remove('fa-angle-up');
	}

	var hiddenParagraph = document.querySelectorAll('.must-opened .subtitle');
	for (var i = 0; i < hiddenParagraph.length; i++) {
		hiddenParagraph[i].classList.toggle('is-hidden-desktop');
	}
	var hiddenColumns = document.querySelectorAll('.must-opened .column');
	for (var i = 0; i < hiddenColumns.length; i++) {
		hiddenColumns[i].classList.toggle('is-opened');
	}
}